import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalOrganisation from "./ModalOrganisation";

const useModalOrganisation = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none', organisation_id: null })  ;

    const onClickActivate = ( organisation_id, mode) =>
    {
        setDialog ({ openState: true, organisation_id: organisation_id, mode: mode});
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, organisation_id: null, mode: 'none'});
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, organisation_id: null, mode: 'none'});

        // Tell the parent we're done
        onSaveCompleted( result ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal key='orgModal' center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalOrganisation key='mo' organisation_id={dialog.organisation_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalOrganisation ;
